module.exports = __webpack_public_path__ + "img/icon_views.d6d7fee0.png";